import { LegalLayout, Section } from "@/components/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Informativa sulla privacy" updated="giugno 2026" testid="privacy-page">
      {(b) => (
        <>
          <Section title="1. Titolare del trattamento">
            <p><b>{b.company_name}</b>{b.company_address ? `, ${b.company_address}` : ""}. Contatto: <a className="text-[#15803D] font-semibold" href={`mailto:${b.company_email}`}>{b.company_email}</a>.</p>
            <p>Questa informativa riguarda il servizio di assistenza clienti tramite WhatsApp Business e il relativo CRM interno, ai sensi del Regolamento (UE) 2016/679 (GDPR).</p>
          </Section>
          <Section title="2. Dati trattati">
            <ul className="list-disc pl-5 space-y-1">
              <li>Numero di telefono WhatsApp e nome del profilo;</li>
              <li>contenuto dei messaggi scambiati (testi, foto, documenti, note vocali);</li>
              <li>dati forniti volontariamente: nome, azienda, email;</li>
              <li>valutazioni di soddisfazione (voto da 1 a 5);</li>
              <li>dati tecnici di consegna dei messaggi forniti da Meta (stato inviato/consegnato/letto).</li>
            </ul>
          </Section>
          <Section title="3. Finalità e base giuridica">
            <ul className="list-disc pl-5 space-y-1">
              <li>Rispondere alle richieste e fornire assistenza (esecuzione di un contratto o misure precontrattuali, art. 6.1.b);</li>
              <li>gestione del rapporto commerciale e qualità del servizio (legittimo interesse, art. 6.1.f);</li>
              <li>messaggi promozionali solo con il tuo consenso, revocabile in ogni momento (art. 6.1.a).</li>
            </ul>
          </Section>
          <Section title="4. Destinatari e trasferimenti">
            <p>I messaggi transitano tramite WhatsApp Business Platform di Meta Platforms Ireland Ltd., che agisce come responsabile del trattamento. I dati sono conservati su infrastruttura cloud con garanzie adeguate (clausole contrattuali standard UE per eventuali trasferimenti extra-UE). Accedono ai dati solo i membri autorizzati del nostro team.</p>
          </Section>
          <Section title="5. Conservazione">
            <p>Conserviamo conversazioni e dati di contatto per il tempo necessario a gestire il rapporto e comunque non oltre 24 mesi dall'ultimo contatto, salvo obblighi di legge.</p>
          </Section>
          <Section title="6. I tuoi diritti">
            <p>Puoi chiedere accesso, rettifica, cancellazione, limitazione, portabilità e opporti al trattamento, scrivendo a {b.company_email}. Puoi inoltre proporre reclamo al Garante per la protezione dei dati personali (garanteprivacy.it).</p>
            <p>Per eliminare i tuoi dati segui le istruzioni nella pagina <a className="text-[#15803D] font-semibold" href="/eliminazione-dati">Eliminazione dati</a>.</p>
          </Section>
          <Section title="7. Sicurezza">
            <p>Accesso protetto da credenziali personali, connessioni cifrate (HTTPS) e verifica della firma dei messaggi provenienti da Meta.</p>
          </Section>
          <Section title="English summary">
            <p>{b.company_name} uses the WhatsApp Business Platform to provide customer support. We process your phone number, profile name and message content only to answer your requests. Data is kept for up to 24 months. Contact {b.company_email} to exercise your GDPR rights or request deletion.</p>
          </Section>
        </>
      )}
    </LegalLayout>
  );
}
